import React, { Component } from 'react'
import {_validateRegistration,_showOverlay,_hideOverlay} from './Constant';
import {_sendMail} from '../api/Api';
let $=window.$;
export default class TalkToUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error_message: {
                email: '',
                first_name: '',
                last_name: '',
                user_name: '',
                country:'',
                phone_number:'',
                message:'',
            },
            registration_error:'',
            registration_success:'',
        }
    }


    async _handleRegistration (e){
        e.preventDefault();
        const data = new FormData(e.target);
         let res=await _validateRegistration(data);
         console.log(res);
             if(res['status']){
                this.setState({
                    error_message:res.error
                });
                let reg=this._sendMail(data);
             }else{
                this.setState({
                    error_message:res.error
                });
             }
    }
    
    /**
     * 
     * @param {*} data 
     */
    _sendMail =async(data)=>{
       
        _showOverlay();
        let email =data.get('email');
        let first_name =data.get('first_name');
        let last_name =data.get('last_name');
        let country =data.get('country');
        let phone_number =data.get('phone_number');
        let message =data.get('message');
        let send_email=this.props.data.email;
        let villa_name=this.props.data.villa_name;
        let res =await _sendMail(email,first_name,last_name,message,country,phone_number,send_email,villa_name);
        if(res.data.response == 'success'){
            let data =res.data.result;
            this.setState({
                  registration_success:res.data.message,
                  registration_error:''
               });
               $('html, body').animate({
                scrollTop: $('#moment-at-the-property').offset().top
            }, 1000);
        }else{
           this.setState({
            registration_error:res.data.message
           });
           $('html, body').animate({
            scrollTop: $('#moment-at-the-property').offset().top
        }, 1000);
           //document.getElementById('moment-at-the-property').scrollIntoView(); 
        }
        _hideOverlay();
    }

    _getCountryOption=()=>{
       
       return Object.values(this.props.data.country_list).map((item,key)=>{
            if(item == 'United Kingdom'){
                return(
                    <option  value={item} key={key} selected>{item}</option>
                );
            } else {
                return(
                    <option  value={item} key={key}>{item}</option>
                );
            }
        });
    }

    componentDidMount =()=>{
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $("#welcome-area").offset().top-50
            }, 500);
        }, 500);
    }


    render() {
        return (
            <div id="welcome-area">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12" id="moment-at-the-property">
                                {/* <h4>{'Talk To Us'}</h4> */}
                                <div className="row py-4">
                                    <form id="enquiry-form" method="post" onSubmit={(e) => this._handleRegistration(e)}>
                                    {typeof this.state.registration_error != 'undefined' && this.state.registration_error !='' ?<div id="login-error" className="login-error mb-4 text-center">{''+this.state.registration_error}</div>:''}
                                    {typeof this.state.registration_success != 'undefined' && this.state.registration_success !='' ?<div id="reg-success" className="bg-success mb-4 text-center">{''+this.state.registration_success}</div>:''}
                                      
                                        <div className="row pl-4">
                                        <div className="form-group col-6">
                                            <label htmlFor="first_name">{this.props.static_text.first_name_text}</label>
                                            <input type="text" className="form-control" id="first_name" name="first_name" placeholder="John" />
                                            <div className="error">{this.state.error_message.first_name}</div>
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="last_name">{this.props.static_text.last_name_text}</label>
                                            <input type="text" className="form-control" id="last_name" name="last_name" placeholder="Doe" />
                                            <div className="error">{this.state.error_message.last_name}</div>
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="email">{this.props.static_text.email_address_text}</label>
                                            <input type="email" className="form-control" id="email" name="email" placeholder="name@example.com" />
                                            <div className="error">{this.state.error_message.email}</div>
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="phone_number">{this.props.static_text.phone_number_text}</label>
                                            <input type="text" className="form-control" id="phone_number" name="phone_number" placeholder="89898989" />
                                            <div className="error">{this.state.error_message.phone_number}</div>
                                        </div>
                                        <div className="form-group col-12">
                                            <label htmlFor="country">{this.props.static_text.select_country_text}</label>
                                            <select type="text" className="form-control" id="country" name="country">
                                                {this._getCountryOption()}
                                            </select>
                                            <div className="error">{this.state.error_message.country}</div>
                                        </div>
                                        <div className="form-group col-12">
                                            <label htmlFor="message">{this.props.static_text.enquiry_text}</label>
                                            <textarea className="form-control" name="message" id="message"></textarea>
                                            <div className="error">{this.state.error_message.message}</div>
                                        </div>
                                        <div className="form-group col-12">
                                            <div className="text-right">  <button className="btn btn-info" id="send">{this.props.static_text.send_enquiry_text}</button></div>
                                          
                                        </div>
                                        </div>
                                       
                                 </form>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
